var n = function n(_n) {
  return null == _n;
};
export { n as i };